import React from 'react';

import { useFeatureFlags } from 'src/context/flagsContext';

import type { TableProps } from './Table';

export * from './AgGridContext';
export * from './HeaderRender';
export * from './Renderer';
export * from './TableResultCount';
export type { SortParams, TableProps } from './Table';

// TODO: AG Grid v27→v35 migration — remove the legacy lazy import and
// the flag-gated branch below once the v35 rollout is complete (Phase 5
// of the migration). Both branches are lazy so the legacy v27 chunk
// (JS + SCSS) and the v35 chunk (JS + portalTheme CSS) each only load
// when their branch renders, preventing cross-contamination of
// `.ag-theme-portal` rules in either direction. The v35 Table accepts
// the same TableProps shape as the legacy component so callers don't
// need to migrate their ColDefs during the rollout; the v35 component
// normalizes legacy fields (e.g. cellRendererFramework) at runtime. The
// `unknown` re-type below is the migration-shim type bridge — v27 and
// v35 ColDef signatures genuinely differ (v27's
// ValueGetterParams.columnApi was merged into v35's GridApi) so there
// is no single overlapping type that satisfies both. This is the only
// cast in the rollout path; it disappears when the legacy code is
// removed at Phase 5.
const LegacyTable = React.lazy(
  () => import(/* webpackChunkName: "legacy-ag-grid-table" */ './Table'),
) as unknown as React.ComponentType<TableProps>;

const NewTable = React.lazy(
  () =>
    import(/* webpackChunkName: "ag-grid-v35" */ 'src/components/AgGrid/Table'),
) as unknown as React.ComponentType<TableProps>;

const Table: React.FC<TableProps> = (props) => {
  const { EnableAgGridUpgrade } = useFeatureFlags();
  const Inner = EnableAgGridUpgrade ? NewTable : LegacyTable;
  return (
    <React.Suspense fallback={null}>
      <Inner {...props} />
    </React.Suspense>
  );
};

export default Table;
